import { useEffect, useState, useRef } from "react";
import tw from "tailwind-styled-components";
import "react-toastify/dist/ReactToastify.css";
import DashboardMetrics from "../../Components/Dashboard/DashboardMetrics";
import axios from "axios";
import Config from "../../Config";
import { useSelector, useDispatch } from "react-redux";
import { useMutation } from "react-query";
import {
  DashboardSkeleton,
  PropertiesOverviewSkeleton,
  OccupancyOverviewSkeleton
} from "../../Components/SkeletonLoading";
import QuickAction from "../../Components/Dashboard/QuickAction";
import Tables from "../../Components/Dashboard/Tables";
import ExpenseIncomeChart from "../../Components/Dashboard/ExpenseIncomeChart";
import OccupancyChart from "../../Components/Dashboard/OccupancyChart";
import { Save_VendorTypes, Save_Partners, Save_PendingTasks, Save_Locations, Select_Property, Select_Location, Save_Staff_Clients, Save_BankAccounts, Save_isStampRequired, Save_isPayoutEnabled, Save_User, Save_StaffList, Save_Vendors } from "../../Redux/actions";
import CollectionSummaryCard from "../../Components/Dashboard/CollectionSummaryCard";
import moment from "moment";
import OperationalInsightsRow from "../../Components/Dashboard/OperationalInsightsRow";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import DateRange from "../../Components/DateRange";
import LocationsFilterDropdown from "../../Components/LocationsFilterDropdown";
import { BoxTitle } from "../../Components/Styles/PageStyles";
import SideModal from "../../Components/SideModal";
import AnalyticsSideModal from "../../Components/Dashboard/AnalyticsSideModal";
import ComplaintAnalyticsSideModal from "../../Components/Dashboard/ComplaintAnalyticsSideModal";
import { hasPermission } from "../../helpers";

import FoodKPIs from "../../Components/Inventory/Dashboard/KPIs";
import SalesKPIs from "../../Components/Sales/Dashboard/KPIs";

import MealResponseChart from "../../Components/Inventory/Dashboard/MealResponseChart";

import PerformanceTable from "../../Components/Sales/Dashboard/PerformanceTable";
import PieChart from "../../Components/Sales/Dashboard/PieChart";
import LeadSourceTable from "../../Components/Sales/Dashboard/LeadSourceTable";
import PurchaseTransferChart from "../../Components/Inventory/Dashboard/PurchaseTransferChart";
import StockPieChart from "../../Components/Inventory/Dashboard/StockPieChart";
import StockTable from "../../Components/Inventory/Dashboard/StockTable";
import PropertiesOverview from "../../Components/DashBoardNew/PropertiesOverview";
import ComplaintsOverview from "../../Components/DashBoardNew/ComplaintsOverview";
import OccupancyOverview from "../../Components/DashBoardNew/OccupancyOverview";

const DASHBOARD_VIEWS = [
  { id: "dashboard", label: "Dashboard", dashboardType: Config.WEB_DASHBOARD_TYPES.MAIN },
  { id: "propertyOverview", label: "Property Overview" },
  { id: "occupancyOverview", label: "Occupancy Overview" },
  { id: "complaintsOverview", label: "Complaints Overview" },

  { id: "leadOverview", label: "Lead Overview", dashboardType: Config.WEB_DASHBOARD_TYPES.SALES },
  { id: "foodOverview", label: "Food Overview", dashboardType: Config.WEB_DASHBOARD_TYPES.KITCHEN },
  // { id: "duesOverview", label: "Dues Overview" },
];

const VIEW_TITLES = Object.fromEntries(
  DASHBOARD_VIEWS.map(({ id, label }) => [id, label])
);

const DashBoardNew = () => {
  const dispatch = useDispatch();

  const viewConfig = {
    dashboard: {
      title: "Dashboard",
      showDateRange: true,
      showProperty: true,
      showLocation: true,
      showApply: true,
    },
    propertyOverview: {
      title: "Property Overview",
      showDateRange: false,
      showProperty: true,
      showLocation: true,
      showApply: false,
    },
    leadOverview: {
      title: "Lead Overview",
      showDateRange: true,
      showProperty: true,
      showLocation: true,
      showApply: true,
    },
    foodOverview: {
      title: "Food Overview",
      showDateRange: true,
      showProperty: true,
      showLocation: true,
      showApply: true,
    },
    complaintsOverview: {
      title: "Complaints Overview",
      showDateRange: true,
      showProperty: true,
      showLocation: true,
      showApply: true,
    },
    occupancyOverview: {
      title: "Occupancy Overview",
      showDateRange: false,
      showProperty: true,
      showLocation: true,
      showApply: false,
    },
    duesOverview: {
      title: "Dues Overview",
      showDateRange: false,
      showProperty: true,
      showLocation: true,
      showApply: false,
    },
  };

  const [activeView, setActiveView] = useState("dashboard");

  const currentView = viewConfig[activeView];

  const [propertyType, setPropertyType] = useState("Current Property");

  const [propertyOverviewData, setPropertyOverviewData] = useState([]);
  const [propertyOverviewLoading, setPropertyOverviewLoading] = useState(false);
  const [propertyOverviewError, setPropertyOverviewError] = useState(false);

  const [occupancyOverviewData, setOccupancyOverviewData] = useState(null);
  const [occupancyOverviewLoading, setOccupancyOverviewLoading] = useState(false);
  const [occupancyOverviewError, setOccupancyOverviewError] = useState(false);

  const user = useSelector((state) => state.UserReducer.user);

  const canViewDashboardNavigation = user?.userType === Config.USER_TYPE.CLIENT || user?.isSuperAdmin === 1 || user?.role === Config.STAFF_ROLES.PARTNER;

  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const selectedPartner = useSelector(
    (state) => state.SelectedPartnerReducer.selectPartner
  );
  const [dashboardType, setDashboardType] = useState(Config.WEB_DASHBOARD_TYPES.MAIN);
  const [loadedDashboardType, setLoadedDashboardType] = useState(null);

  const canViewFinance = hasPermission("VIEW_FINANCIAL_SUMMARY", user);
  const canViewCollections = hasPermission("MANANGE_COLLECTIONS", user);

  const defaultLocations = {
    id: 0,
    name: "All Locations",
    clientId: 0,
  };

  const [overviewProperty, setOverviewProperty] = useState(property);
  const [overviewLocation, setOverviewLocation] = useState(defaultLocations);

  const [apiData, setApiData] = useState();
  const [clientSummary, setClientSummary] = useState();
  //const [allPropertySummary, setAllPropertySummary] = useState();
  const [currentPropertySummary, setCurrentPropertySummary] = useState();
  const [recentTransaction, setRecentTransaction] = useState();
  const [expenseStats, setExpenseStats] = useState();
  const [expanseAllMonthlyGraph, setExpanseAllMonthlyGraph] = useState();
  const [purchaseTransferGraph, setPurchaseTransferGraph] = useState();
  const [stockTableData, setStockTableData] = useState();
  const [stockPieChart, setStockPieChart] = useState();
  const [expanseCurrMonthlyGraph, setExpanseCurrMonthlyGraph] = useState();
  const [expanseCurrYearlyGraph, setExpanseCurrYearlyGraph] = useState();
  const [expanseAllYearlyGraph, setExpanseAllYearlyGraph] = useState();
  const [allOccupancyGraph, setAllOccupancyGraph] = useState();
  const [currOccupancyGraph, setCurrOccupancyGraph] = useState();
  const [complaintSummary, setComplaintSummary] = useState();
  const [businessImpactSummary, setBusinessImpactSummary] = useState();

  const [leadSourceSummary, setLeadSourceSummary] = useState();
  const [leadSummary, setLeadSummary] = useState();

  const [staffSummary, setStaffSummary] = useState();
  const [foodSummary, setFoodSummary] = useState();
  const [staffPerformance, setStaffPerformance] = useState();
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const calendarRef = useRef(null);

  const lastFetchRef = useRef(null);

  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  const [selectedProperty, setSelectedProperty] = useState(property);
  const [selectedLocation, setSelectedLocation] = useState(defaultLocations);
  const properties = useSelector((state) => state.PropertyReducer.property);
  const locations = useSelector((state) => state.LocationsReducer.locations);
  const [isShowAnalytics, setIsShowAnalytics] = useState(false);
  const [isShowComplaintAnalytics, setIsShowComplaintAnalytics] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(() => ({
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
    propertyId: property?.id ?? 0,
    locationId: defaultLocations.id,
  }));

  const filteredProperties =
    selectedLocation?.id === 0
      ? properties
      : [
        properties[0],
        ...properties.filter(
          (p) =>
            p.locationId === selectedLocation.id ||
            p.location?.id === selectedLocation.id
        ),
      ];

  const overviewFilteredProperties =
    overviewLocation?.id === 0
      ? properties
      : [
        properties?.[0],
        ...(properties || []).filter(
          (p) =>
            p.locationId === overviewLocation?.id ||
            p.location?.id === overviewLocation?.id
        ),
      ].filter(Boolean);

  const handleOverviewPropertySelect = (selected) => {
    setOverviewProperty(selected);
  };

  const handleOverviewLocationSelect = (location) => {
    setOverviewLocation(location);
    setOverviewProperty(properties?.[0] ?? property);
  };


  const [complaintsSelectedProperty, setComplaintsSelectedProperty] =
    useState(property);

  const [complaintsSelectedLocation, setComplaintsSelectedLocation] =
    useState(defaultLocations);

  const [appliedComplaintsFilters, setAppliedComplaintsFilters] =
    useState({
      propertyId: property?.id ?? 0,
      locationId: 0,
    });

  const complaintsFilteredProperties =
    complaintsSelectedLocation?.id === 0
      ? properties || []
      : (properties || []).filter(
        (item) =>
          item.id === properties?.[0]?.id ||
          item.locationId === complaintsSelectedLocation.id ||
          item.location?.id === complaintsSelectedLocation.id
      );

  const handleComplaintsLocationSelect = (location) => {
    setComplaintsSelectedLocation(location);

    // Reset property selection when the location changes.
    setComplaintsSelectedProperty(properties?.[0] ?? property);
  };

  const handleApplyComplaintsFilters = () => {
    setAppliedComplaintsFilters({
      propertyId: complaintsSelectedProperty?.id ?? 0,
      locationId: complaintsSelectedLocation?.id ?? 0,
    });
  };

  const complaintsCanApply =
    (complaintsSelectedProperty?.id ?? 0) !==
    appliedComplaintsFilters.propertyId ||
    (complaintsSelectedLocation?.id ?? 0) !==
    appliedComplaintsFilters.locationId;

  useEffect(() => {
    if (!selectedLocation || !properties?.length) return;

    // If All Locations selected → force All Properties
    if (selectedLocation?.id === 0) {
      setSelectedProperty(properties[0]);
      dispatch(Select_Property(properties[0]));

      if (locations && locations.length > 0) {
        setSelectedLocation(locations[0]);
        dispatch(Select_Location(locations[0]));
      }
      return;
    }

    const isPropertyValid = properties.some(
      (p) =>
        p.id === selectedProperty?.id &&
        (p.locationId === selectedLocation.id ||
          p.location?.id === selectedLocation.id)
    );

    if (!isPropertyValid) {
      setSelectedProperty(properties[0]); // 👈 index 0
      dispatch(Select_Property(properties[0]));
    }
  }, [selectedLocation, properties]);

  useEffect(() => {
    if (activeView !== "propertyOverview" || !user?.token) return;

    const controller = new AbortController();

    const fetchPropertyOverview = async () => {
      setPropertyOverviewLoading(true);
      setPropertyOverviewError(false);

      try {
        const params = new URLSearchParams({
          propId: String(overviewProperty?.id ?? 0),
          locationId: String(overviewLocation?.id ?? 0),
        });

        const response = await axios.get(
          `${Config.apiUrl}/property/analytics/combined/dashboard?${params.toString()}`,
          {
            headers: {
              authorization: `Bearer ${user.token}`,
              "Content-Type": "application/json",
            },
            signal: controller.signal,
          }
        );

        if (response.data?.isSuccess === false) {
          throw new Error("Unable to fetch property overview");
        }

        // Adjust this path to match the actual API response.
        setPropertyOverviewData({
          combined: response.data?.data?.combinedDashboardData?.[0] ?? null,
          properties: response.data?.data?.propertyWiseDashboardData ?? [],
        });
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          setPropertyOverviewError(true);
          console.error("Property overview API error:", error);
        }
      } finally {
        if (!controller.signal.aborted) {
          setPropertyOverviewLoading(false);
        }
      }
    };

    fetchPropertyOverview();

    return () => controller.abort();
  }, [
    activeView,
    user?.token,
    overviewProperty?.id,
    overviewLocation?.id,
  ]);


  useEffect(() => {
    if (activeView !== "occupancyOverview") {
      return;
    }

    if (!user?.token) {
      console.warn("Occupancy API skipped: authentication token is missing");
      return;
    }

    const controller = new AbortController();

    const fetchOccupancyOverview = async () => {
      setOccupancyOverviewLoading(true);
      setOccupancyOverviewError(false);

      try {
        const url = `${Config.apiUrl}/client/occupancy/overview`;

        const params = {
          locationId: overviewLocation?.id ?? 0,
          propId: overviewProperty?.id ?? 0,
        };

        const response = await axios.get(url, {
          params,
          headers: {
            authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        });

        setOccupancyOverviewData(
          response.data?.data ?? response.data
        );
      } catch (error) {
        if (axios.isCancel(error) || error.code === "ERR_CANCELED") {
          return;
        }

        console.error(
          "Occupancy API failed:",
          error.response?.status,
          error.response?.data || error.message
        );

        setOccupancyOverviewError(true);
      } finally {
        if (!controller.signal.aborted) {
          setOccupancyOverviewLoading(false);
        }
      }
    };

    fetchOccupancyOverview();

    return () => controller.abort();
  }, [
    activeView,
    user?.token,
    overviewProperty?.id,
    overviewLocation?.id,
  ]);

  const onApplyFilters = () => {
    dispatch(Select_Property(selectedProperty));
    dispatch(Select_Location(selectedLocation));

    const formattedDate = moment(selectedDate).format("YYYY-MM-DD");

    if (dashboardType === Config.WEB_DASHBOARD_TYPES.KITCHEN) {
      setStartDate(formattedDate);
      setEndDate(formattedDate);

      setAppliedFilters({
        startDate: formattedDate,
        endDate: formattedDate,
        propertyId: selectedProperty?.id ?? 0,
        locationId: selectedLocation?.id ?? 0,
      });

      return;
    }

    setAppliedFilters({
      startDate,
      endDate,
      propertyId: selectedProperty?.id ?? 0,
      locationId: selectedLocation?.id ?? 0,
    });
  };

  // const canApply =
  //   !appliedFilters ||
  //   appliedFilters.startDate !== startDate ||
  //   appliedFilters.endDate !== endDate ||
  //   appliedFilters.propertyId !== selectedProperty?.id ||
  //   appliedFilters.locationId !== selectedLocation?.id;

  const selectedDateFormatted = moment(selectedDate).format("YYYY-MM-DD");

  const canApply =
    !appliedFilters ||
    (dashboardType === Config.WEB_DASHBOARD_TYPES.KITCHEN
      ? appliedFilters.startDate !== selectedDateFormatted ||
      appliedFilters.endDate !== selectedDateFormatted ||
      appliedFilters.propertyId !== selectedProperty?.id
      : appliedFilters.startDate !== startDate ||
      appliedFilters.endDate !== endDate ||
      appliedFilters.propertyId !== selectedProperty?.id ||
      appliedFilters.locationId !== selectedLocation?.id);

  const fetchFunction = async ({ dashboardType }) => {
    const query = buildQuery(dashboardType);
    const response = await axios.get(
      `${Config.apiUrl}/property/web/dashboard/${property?.id}?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);

      //setAllPropertySummary(res?.allPropCollectionSummary);
      setCurrentPropertySummary(res?.curPropCollectionSummary);
      //setRecentTransaction(res?.recentTransactions);
      //setExpenseStats(res?.expenseStats);
      //setExpanseAllMonthlyGraph(res?.expenseGraph?.allProps?.monthlyData);
      //setExpanseAllYearlyGraph(res?.expenseGraph?.allProps?.yearlyData);
      //setExpanseCurrYearlyGraph(res?.expenseGraph?.curProp?.yearlyData);
      //setExpanseCurrMonthlyGraph(res?.expenseGraph?.curProp?.monthlyData);
      //setAllOccupancyGraph(res?.occupancyGraph?.allProps);
      //setCurrOccupancyGraph(res?.occupancyGraph?.curProps);
      dispatch(Save_VendorTypes(res?.vendorTypes || []));
      dispatch(Save_Vendors(res?.vendors || []));
      dispatch(Save_StaffList(res?.staffList || []));

      const realData = {
        ...user,       // keep existing user data
        defaultTenantFilter: res?.defaultTenantFilter || '',
        isSuperAdmin: res?.isSuperAdmin || 0
      };

      dispatch(Save_User(realData));

      if (user.userType === Config.USER_TYPE.STAFF) {
        dispatch(Save_Staff_Clients(res?.staffAccounts));
      }
      if (res?.pendingTasks) {
        dispatch(Save_PendingTasks(res.pendingTasks));
      }
      if (res?.locations) {
        dispatch(Save_Locations([defaultLocations, ...res.locations]));
      }
      //setBusinessImpactSummary(res?.businessImpact);
      //setComplaintSummary(res?.complaintSummary);
      if (res?.bankAccounts) {
        dispatch(Save_BankAccounts(res.bankAccounts));
      }
      if (res?.isStampPaperRequired != null) {
        dispatch(Save_isStampRequired(res.isStampPaperRequired));
      }

      if (res?.isPayoutEnabled != null) {
        dispatch(Save_isPayoutEnabled(res.isPayoutEnabled));
      }

      /* Dashboard-specific data
            */
      switch (dashboardType) {
        case Config.WEB_DASHBOARD_TYPES.MAIN:
          setClientSummary(res?.clientSummary);
          setCurrentPropertySummary(
            res?.curPropCollectionSummary
          );

          setExpenseStats(
            res?.expenseStats
          );

          setExpanseAllMonthlyGraph(
            res?.expenseGraph?.allProps?.monthlyData
          );

          setExpanseAllYearlyGraph(
            res?.expenseGraph?.allProps?.yearlyData
          );

          setExpanseCurrYearlyGraph(
            res?.expenseGraph?.curProp?.yearlyData
          );

          setExpanseCurrMonthlyGraph(
            res?.expenseGraph?.curProp?.monthlyData
          );

          setAllOccupancyGraph(
            res?.occupancyGraph?.allProps
          );

          setCurrOccupancyGraph(
            res?.occupancyGraph?.curProps
          );

          setBusinessImpactSummary(
            res?.businessImpact
          );

          setComplaintSummary(
            res?.complaintSummary
          );

          // Clear Sales/Food specific data
          setStaffSummary(undefined);
          setFoodSummary(undefined);
          setLeadSourceSummary(undefined);
          setPurchaseTransferGraph(undefined);
          setStockPieChart(undefined);
          setStockTableData(undefined);
          if (user.userType === Config.USER_TYPE.CLIENT) {
            dispatch(Save_Partners(res?.personalAndPartnerProperties));
          }

          break;

        case Config.WEB_DASHBOARD_TYPES.SALES:
          setLeadSummary(res?.summary || []);
          setStaffPerformance(res?.staffSummary || []);
          setLeadSourceSummary(
            res?.leadSourceSummary || []
          );

          // Clear Main/Food specific data
          setCurrentPropertySummary(undefined);
          setExpenseStats(undefined);
          setExpanseAllMonthlyGraph(undefined);
          setExpanseAllYearlyGraph(undefined);
          setExpanseCurrYearlyGraph(undefined);
          setExpanseCurrMonthlyGraph(undefined);
          setAllOccupancyGraph(undefined);
          setCurrOccupancyGraph(undefined);
          setBusinessImpactSummary(undefined);
          setComplaintSummary(undefined);

          setStaffSummary(undefined);
          setFoodSummary(undefined);
          setPurchaseTransferGraph(undefined);
          setStockPieChart(undefined);
          setStockTableData(undefined);
          break;

        case Config.WEB_DASHBOARD_TYPES.KITCHEN:
          // Food dashboard currently uses summary
          // and MealResponseChart.
          //
          // Keep summary in clientSummary.
          // Add food-specific response fields here
          // if the API returns them separately.
          setFoodSummary(res?.summary);
          setPurchaseTransferGraph(res?.purchaseTransferGraphData)
          setStockPieChart(res?.itemSummary)
          setStockTableData(res?.inventoryStocks);
          // Clear Sales-specific data
          //setStaffSummary(res?.summary || []);
          setLeadSourceSummary(undefined);

          // Clear Main-specific data
          setCurrentPropertySummary(undefined);
          setExpenseStats(undefined);
          setExpanseAllMonthlyGraph(undefined);
          setExpanseAllYearlyGraph(undefined);
          setExpanseCurrYearlyGraph(undefined);
          setExpanseCurrMonthlyGraph(undefined);
          setAllOccupancyGraph(undefined);
          setCurrOccupancyGraph(undefined);
          setBusinessImpactSummary(undefined);
          setComplaintSummary(undefined);

          break;

        default:
          break;
      }
    }
    setLoadedDashboardType(dashboardType);
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  const buildQuery = (type) => {
    const params = new URLSearchParams();

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (selectedLocation?.id) params.append("locationId", selectedLocation.id);
    if (selectedProperty?.id) params.append("propertyId", selectedProperty.id);
    params.append("dashboardType", type);
    return params.toString();
  };

  const submitHandler = (values) => {
    setStartDate(moment(values.startDate).format("YYYY-MM-DD"));
    setEndDate(moment(values.endDate).format("YYYY-MM-DD"));
  };

  //dispatch(Select_Property(property))

  const handlePropertySelect = (property) => {
    setSelectedProperty(property);
  };

  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
  };

  // Partner change → reset filters ONCE
  useEffect(() => {
    if (!selectedPartner?.clientId) return;

    setAppliedFilters({
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      endDate: moment().endOf("month").format("YYYY-MM-DD"),
      propertyId: 0,
      locationId: 0,
    });
  }, [selectedPartner?.clientId]);

  // useEffect(() => {
  //   if (!appliedFilters) return;

  //   getListMutate();
  // }, [appliedFilters, getListMutate]);

  useEffect(() => {
    if (!appliedFilters || !user?.token) return;

    const signature = JSON.stringify({
      token: user.token,
      filters: appliedFilters,
      dashboardType
    });

    if (lastFetchRef.current === signature) return;

    lastFetchRef.current = signature;
    getListMutate({ dashboardType });
  }, [appliedFilters, user?.token, dashboardType]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setIsCalendarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setIsCalendarOpen(false);
    //getListMutate(date);
  };

  const toggleCalendar = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };

  const handleDashboardChange = (type) => {
    if (type === Config.WEB_DASHBOARD_TYPES.KITCHEN) {
      const today = moment().format("YYYY-MM-DD");

      setSelectedDate(new Date());
      setStartDate(today);
      setEndDate(today);

      setAppliedFilters(prev => ({
        ...prev,
        startDate: today,
        endDate: today,
      }));
    }
    else {
      const monthStart = moment().startOf("month").format("YYYY-MM-DD");
      const monthEnd = moment().endOf("month").format("YYYY-MM-DD");

      setStartDate(monthStart);
      setEndDate(monthEnd);

      setAppliedFilters(prev => ({
        ...prev,
        startDate: monthStart,
        endDate: monthEnd,
      }));
    }

    setDashboardType(type);
  };


  const createDefaultViewFilters = () => ({
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
    propertyId: property?.id ?? 0,
    locationId: 0,
    selectedDate: moment().format("YYYY-MM-DD"),
  });

  const [viewFilters, setViewFilters] = useState(() =>
    Object.fromEntries(
      DASHBOARD_VIEWS
        .filter(({ id }) => id !== "dashboard")
        .map(({ id }) => [id, createDefaultViewFilters()])
    )
  );

  const updateViewFilter = (viewId, key, value) => {
    setViewFilters((previous) => ({
      ...previous,
      [viewId]: {
        ...previous[viewId],
        [key]: value,
      },
    }));
  };

  const handleViewChange = (viewId) => {
    setActiveView(viewId);

    const selectedView = DASHBOARD_VIEWS.find(
      (view) => view.id === viewId
    );

    if (selectedView?.dashboardType) {
      setDashboardType(selectedView.dashboardType);
    }
  };

  return (
    <Container>
      {canViewDashboardNavigation && (
        <ScreenNavigation
          activeView={activeView}
          onChange={handleViewChange}
          views={DASHBOARD_VIEWS}
        />
      )}
      <DashboardHeader
        title={VIEW_TITLES[activeView] ?? "Dashboard"}
        count={
          activeView === "propertyOverview"
            ? propertyOverviewData.properties?.length ?? 0
            : undefined
        }
      >
        {/* Dashboard, Lead Overview and Food Overview */}
        {["dashboard", "leadOverview", "foodOverview"].includes(
          activeView
        ) && (
            <>
              {dashboardType === Config.WEB_DASHBOARD_TYPES.MAIN && (
                <DateRange
                  submitHandler={submitHandler}
                  defaultLabel={`${moment(startDate).format(
                    "DD MMM yyyy"
                  )} - ${moment(endDate).format("DD MMM yyyy")}`}
                />
              )}

              {dashboardType === Config.WEB_DASHBOARD_TYPES.KITCHEN && (
                <div className="relative" ref={calendarRef}>
                  {/* Keep your existing Food date-picker/calendar JSX here */}
                </div>
              )}

              <PropertiesFilterDropdown
                properties={filteredProperties}
                selectedProperty={selectedProperty}
                onPropertySelect={handlePropertySelect}
                placeholder="All Properties"
                className="w-full md:w-[200px]"
              />

              {dashboardType !== Config.WEB_DASHBOARD_TYPES.KITCHEN && (
                <LocationsFilterDropdown
                  locations={locations}
                  selectedLocation={selectedLocation}
                  onSelect={handleLocationSelect}
                  placeholder="All Locations"
                  className="w-full md:w-[200px]"
                />
              )}

              <ApplyButton
                disabled={!canApply}
                type="button"
                onClick={onApplyFilters}
                className="md:ml-2 self-center md:self-auto"
              >
                Apply
              </ApplyButton>
            </>
          )}

        {/* Complaints Overview */}
        {activeView === "complaintsOverview" && (
          <>
            <PropertiesFilterDropdown
              properties={complaintsFilteredProperties}
              selectedProperty={complaintsSelectedProperty}
              onPropertySelect={setComplaintsSelectedProperty}
              placeholder="All Properties"
              className="w-full md:w-[200px]"
            />

            <LocationsFilterDropdown
              locations={locations}
              selectedLocation={complaintsSelectedLocation}
              onSelect={handleComplaintsLocationSelect}
              placeholder="All Locations"
              className="w-full md:w-[200px]"
            />

            <ApplyButton
              disabled={!complaintsCanApply}
              type="button"
              onClick={handleApplyComplaintsFilters}
              className="md:ml-2 self-center md:self-auto"
            >
              Apply
            </ApplyButton>
          </>
        )}

        {/* Property, Occupancy and Dues Overview */}
        {["propertyOverview", "occupancyOverview", "duesOverview"].includes(
          activeView
        ) && (
            <>
              <PropertiesFilterDropdown
                properties={overviewFilteredProperties}
                selectedProperty={overviewProperty}
                onPropertySelect={handleOverviewPropertySelect}
                placeholder="All Properties"
                className="w-full md:w-[200px]"
              />

              <LocationsFilterDropdown
                locations={locations}
                selectedLocation={overviewLocation}
                onSelect={handleOverviewLocationSelect}
                placeholder="All Locations"
                className="w-full md:w-[200px]"
              />

              {currentView?.showApply && (
                <ApplyButton
                  type="button"
                  onClick={onApplyFilters}
                  className="md:ml-2 self-center md:self-auto"
                >
                  Apply
                </ApplyButton>
              )}
            </>
          )}
      </DashboardHeader>

      {activeView === "complaintsOverview" && (
        <ComplaintsOverview
          token={user?.token}
          filters={appliedComplaintsFilters}
        />
      )}


      {activeView === "occupancyOverview" && (
        occupancyOverviewLoading ? (
          <OccupancyOverviewSkeleton />
        ) : occupancyOverviewError ? (
          <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
            Unable to load occupancy overview. Please try again.
            <button
              type="button"
              className="ml-2 font-semibold underline"
              onClick={() => {
                setOccupancyOverviewError(false);
                setActiveView("dashboard");
                setActiveView("occupancyOverview");
              }}
            >
              Retry
            </button>
          </div>
        ) : (
          <OccupancyOverview data={occupancyOverviewData} />
        )
      )}


      {activeView === "propertyOverview" ? (
        propertyOverviewLoading ? (
          <PropertiesOverviewSkeleton />
        ) : propertyOverviewError ? (
          <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
            Unable to load property overview. Please try again.
            <button
              type="button"
              className="ml-2 font-semibold underline"
              onClick={() => setActiveView("dashboard")}
            >
              Back to Dashboard
            </button>
          </div>
        ) : (
          <PropertiesOverview
            data={propertyOverviewData.properties}
            combinedData={propertyOverviewData.combined}
          />
        )
      ) : ["dashboard", "leadOverview", "foodOverview"].includes(
        activeView
      ) ? (
        <>
          {(isLoading || isRefetching) && <DashboardSkeleton />}
          {!error &&
            !isLoading &&
            !isRefetching &&
            apiData &&
            loadedDashboardType === dashboardType && (
              <>
                {dashboardType === Config.WEB_DASHBOARD_TYPES.MAIN && loadedDashboardType === Config.WEB_DASHBOARD_TYPES.MAIN && (
                  <>
                    <DashboardMetrics
                      data={clientSummary}
                      setIsShowAnalytics={setIsShowAnalytics}
                      canViewFinance={canViewFinance}
                    />
                    {canViewCollections &&
                      <CollectionSummaryCard
                        clientSummary={clientSummary}
                        currentPropertySummary={currentPropertySummary}
                        expenseStats={expenseStats}
                        complaintSummary={complaintSummary}
                        canViewFinance={canViewFinance}
                      />
                    }

                    <OperationalInsightsRow
                      impactSummary={businessImpactSummary}
                      complaintSummary={complaintSummary}
                      setIsShowComplaintAnalytics={setIsShowComplaintAnalytics}
                    />

                    <TwoColGrid>
                      {canViewCollections ? (
                        <ExpenseIncomeChart
                          property={property}
                          allMonthlyData={expanseAllMonthlyGraph}
                          allYearlyData={expanseAllYearlyGraph}
                          currMonthlyData={expanseCurrMonthlyGraph}
                          currYearlyData={expanseCurrYearlyGraph}
                          propertyType={propertyType}
                          setPropertyType={setPropertyType}
                        />
                      ) : (
                        <QuickAction />
                      )}

                      <OccupancyChart
                        allOccupancyData={allOccupancyGraph}
                        currOccupancyData={currOccupancyGraph}
                        property={property}
                        propertyType={propertyType}
                        setPropertyType={setPropertyType}
                      />
                    </TwoColGrid>

                    {canViewCollections &&
                      <div className="grid md:grid-cols-2 grid-cols-1 gap-6 mt-6 pb-12">
                        <QuickAction />
                        <Tables
                          recentTransaction={recentTransaction}
                          propertyType={propertyType}
                          setPropertyType={setPropertyType}
                        />
                      </div>
                    }
                  </>
                )}

                {dashboardType === Config.WEB_DASHBOARD_TYPES.KITCHEN && (
                  <>
                    <FoodKPIs
                      data={foodSummary}
                      setIsShowAnalytics={setIsShowAnalytics}
                      canViewFinance={false}
                    />

                    <TwoColGrid >
                      <MealResponseChart
                        summary={foodSummary}
                      />
                      <StockPieChart
                        summary={stockPieChart}
                      />
                    </TwoColGrid>
                    <TwoColGrid className="pb-12">
                      <PurchaseTransferChart
                        purchaseTransferGraph={purchaseTransferGraph}
                      />

                      <StockTable
                        stockTableData={stockTableData}
                      />
                    </TwoColGrid>
                  </>
                )}

                {dashboardType === Config.WEB_DASHBOARD_TYPES.SALES && (
                  <>
                    <SalesKPIs
                      data={leadSummary}
                      setIsShowAnalytics={setIsShowAnalytics}
                      canViewFinance={false}
                    />

                    <div className="grid grid-cols-1 gap-6 mt-6">
                      <PerformanceTable
                        staffSummary={staffPerformance}
                      />
                    </div>

                    <TwoColGrid className="pb-12">
                      <PieChart
                        leadSourceSummary={leadSourceSummary}
                      />

                      <LeadSourceTable
                        leadSourceSummary={leadSourceSummary}
                      />
                    </TwoColGrid>
                  </>
                )}

                <SideModal
                  isOpen={isShowAnalytics}
                  onClose={() => setIsShowAnalytics(false)}
                >
                  <AnalyticsSideModal
                    isOpen={isShowAnalytics}
                    handleClose={() => setIsShowAnalytics(false)}
                    token={user.token}
                  />
                </SideModal>

                <SideModal
                  isOpen={isShowComplaintAnalytics}
                  onClose={() => setIsShowComplaintAnalytics(false)}
                >
                  <ComplaintAnalyticsSideModal
                    isOpen={isShowComplaintAnalytics}
                    handleClose={() => setIsShowComplaintAnalytics(false)}
                    token={user.token}
                  />
                </SideModal>
              </>
            )
          }
        </>
      ) : null}
    </Container >
  );
};

const DashboardHeader = ({ title, count, children }) => (
  <Card>
    <Wrapper>
      <TitleWrapper>
        <div className="flex items-center gap-3">
          <BoxTitle className="!mb-0">
            {title}
          </BoxTitle>

          {count !== undefined && (
            <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-primary-color">
              {count.toLocaleString("en-IN")} Properties
            </span>
          )}
        </div>
      </TitleWrapper>

      <ActionsWrapper>{children}</ActionsWrapper>
    </Wrapper>
  </Card>
);

const ScreenNavigation = ({ activeView, onChange, views }) => (
  <div className="mb-4 mt-3 overflow-x-auto border-b border-gray-200">
    <div className="flex min-w-max items-center gap-1">
      {views.map(({ id, label }) => (
        <button
          key={id}
          type="button"
          onClick={() => onChange(id)}
          aria-current={activeView === id ? "page" : undefined}
          className={`whitespace-nowrap border-b-2 px-4 py-3 text-sm font-medium transition-colors ${activeView === id
            ? "border-primary-color text-primary-color"
            : "border-transparent text-gray-500 hover:text-gray-800"
            }`}
        >
          {label}
        </button>
      ))}
    </div>
  </div>
);

const Container = tw.div`Container`;
const TwoColGrid = tw.div`
  grid grid-cols-1 md:grid-cols-2 gap-6 mt-6
`;
const ApplyButton = tw.button`
  px-5 py-2
  rounded-md
  text-sm font-medium
  transition
  shadow-sm

  ${({ disabled }) =>
    disabled
      ? `
        bg-gray-200
        text-gray-400
        cursor-not-allowed
      `
      : `
        bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110
        text-white
      `}
`;

const Card = tw.div`mt-2 md:mt-7 bg-white rounded-lg shadow-sm`;

const Wrapper = tw.div`flex flex-col lg:flex-row lg:items-center gap-4 px-4 py-3 md:px-6`;

const TitleWrapper = tw.div`shrink-0`;

const ActionsWrapper = tw.div`flex flex-col md:flex-row md:items-center gap-3 flex-1 justify-end p-2`;


export default DashBoardNew;
